import React, { useEffect, useMemo } from 'react'
import { useInstData } from '../../public/hooks'

export default props => {
    const { setState, me, me: {
        state: {
            flowRecordId, id, name, fieldset
        }
    } } = useInstData(props, useMemo(() => ({
        state: {
            flowRecordId: props.flowRecordId,
            id: props.id,
            name: props.name,
            fieldset: [
                { _label: '装载中，请稍等...' }
            ],
        }
    })))

    const { onClose, showBody: Body } = props

    const loadComponent = ({ /* name,  */type, ...field }) => {
        type == '_depselect' && (field = loadDepSelect(field))
        type == '_border' && field.items && (field.items = field.items.map(item => {
            return loadComponent(item)
        }))
        return field
    }

    const loadDepSelect = (field) => {
        return { _text: field._depselect, name: field.name + '_fullName', minWidth: '95%', disabled: true, required: true }
    }

    const handleLoadForm = () => {
        const stamp = me.refreshStamp = Date.now()
        Tyan.doPostEvent('GetFlowRecordGrid', {
            data: { flowRecordId, name },
            onEnd: ({ errorMessage, components }) => {
                if (me.refreshStamp != stamp || me.unmounted) return
                if (errorMessage) {
                    Ext.toast(`读取流程配置数据失败: ${errorMessage}`)
                    console.error('读取流程配置数据失败:', errorMessage)
                    onClose()
                    return
                }
                const fieldset = components && components.map(comp => {
                    return loadComponent(comp)
                })
                setState({ fieldset })
                handleRefresh()
            }
        })
    }

    const handleRefresh = () => { 
        const stamp = me.refreshStamp = Date.now()
        Tyan.doPostEvent('GetFlowRecordGridData', {
            data: { flowRecordId, id, name },
            onEnd: ({ errorMessage, initValues }) => {
                if (me.refreshStamp != stamp || me.unmounted) return
                if (errorMessage) {
                    Ext.toast(`读取流程数据失败: ${errorMessage}`)
                    return
                }
                setState({ initValues })
            }
        })
    }

    useEffect(() => {
        handleLoadForm()
    }, [])

    return <Body data={me} isDialog={true} maxWidth="690"
        controls={[{ _button: '关闭', handler: onClose }]}
        fieldsets={[{ title: '', name: '', _fieldset: fieldset, disabled: true }]}
    />
}